"use client"
import React, { useState, useEffect } from "react";
import "@/components/locator/LocatorSearchComponent.css";

const LocatorSearchComponent = ({
  defaultText,
  onChange,
  previewOpen,
  searchResultsOpen,
  searchMode,
  onEnterPressed,
  onFocus,
  onBlur
}) => {
  const [searchText, setSearchText] = useState("");

  const searchModePlaceholder = {
    service: "Search by item",
    business: "Search",
    properties: "Search",
    vendor: "Search"
  };

  useEffect(() => {
    setSearchText(defaultText ?? "");
  }, [defaultText]);

  const onChangeHandler = value => {
    onChange(value);
  };

  return (
    <div
      className={`locator-search-component ${
        searchResultsOpen ? "search-results-open" : ""
      }`}
    >
      <div
        className={`search-input-container ${
          previewOpen ? "preview-open" : ""
        }`}
      >
        <input
          type="text"
          placeholder={searchModePlaceholder[searchMode] ?? "Search"}
          className="search-input"
          value={searchText}
          onChange={e => {
            setSearchText(e.target.value);
            onChangeHandler(e.target.value);
          }}
          onFocus={() => onFocus?.()}
          onBlur={() => onBlur?.()}
          onKeyDown={e => {
            if (e.key === "Enter") {
              onEnterPressed(e.target.value);
            }
          }}
        />
        <i className="fa-solid fa-magnifying-glass"></i>
        {searchText != "" && (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSearchText("");
              onChange("");
            }}
          >
            <i className="fa-solid fa-xmark-large"></i>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocatorSearchComponent;
